/*============================================================================
Hero Slick Carousel - Updated 2021-01-21 by Shopify Plus FED - Allow alternate mobile image
==============================================================================*/
var Plus = window.Plus || {};
Plus.responsiveHeroCarousel = Plus.responsiveHeroCarousel || {};

Plus.responsiveHeroCarousel = {
    currentWindowWidth: window.innerWidth,
    currentWindowWidthDevice: '',
    carouselSlides: $('.carousel-container2 .carousel-image'),
    carouselImageDataAttr: '',
};

var plusBuildSlideshow = function() {
    var settings = window.Plus.responsiveHeroCarousel;

    if (settings.currentWindowWidth > 768) {
        settings.carouselImageDataAttr = 'data-plus-image-desktop';
        settings.currentWindowWidthDevice = 'desktop';
    } else {
        settings.carouselImageDataAttr = 'data-plus-image-mobile';
        settings.currentWindowWidthDevice = 'mobile';
    };

    settings.carouselSlides.each(function(){
        var imgUrl = $(this).attr(settings.carouselImageDataAttr);
        var imgLink = $(this).attr('data-plus-image-link');
        var elementToAdd = '<a href="' + imgLink + '"><img src="' + imgUrl + '" class="plus-hero-carousel_image"></a>';

        if ($(this).find('img.plus-hero-carousel_image').length > 0) {
            $(this).find('img.plus-hero-carousel_image').attr('src', imgUrl);
        } else {
            $(this).append(elementToAdd);
        }
    });

    $('.carousel-container2').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        nextArrow: '.carousel-container .arrow-right i',
        prevArrow: '.carousel-container .arrow-left i'
    });
}

// Window resize listener that checks if the screen is switching between mobile/desktop and rebuilds the carousel if that happens.
var plusResponsiveCarouselResizeListener = function () {
    $(window).resize(function(){
        var settings =  window.Plus.responsiveHeroCarousel;
        var newWindowSize = window.innerWidth > 768 ? 'desktop' : 'mobile';

        if (settings.currentWindowWidthDevice != newWindowSize) {
            settings.carouselSlides = $('.carousel-container2 .carousel-image');
            settings.currentWindowWidth = window.innerWidth;
            
            if (settings.currentWindowWidth > 768) {
                settings.carouselImageDataAttr = 'data-plus-image-desktop';
                settings.currentWindowWidthDevice = 'desktop';
            } else {
                settings.currentWindowWidth = 'data-plus-image-mobile';
                settings.currentWindowWidthDevice = 'mobile';
            };

            $('.carousel-container2').slick('unslick');
            plusBuildSlideshow();
        }
    });
};

plusBuildSlideshow();
plusResponsiveCarouselResizeListener();

/*============================================================================
Featured Collection Change Border Bottom On Hover
==============================================================================*/
$('.featured-collection-link').each(function(){
    $(this).hover(function(){
        $(this).find('.featured-collection-title').toggleClass('featured-collection-change-border');
    });
});


/*============================================================================
Collections Page Change Roast Type Abbreviation On Hover
==============================================================================*/
$('.roast-type a').each(function(){
    $(this).hover(function(){
        $(this).find('.abbr').toggleClass('abbr-hover');
    });
});


/*============================================================================
Collection.liquid Carousel
==============================================================================*/
$('.collection-carousel').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    nextArrow: '.collection-carousel-container .collection-arrow-right i',
    prevArrow: '.collection-carousel-container .collection-arrow-left i'
});


/*============================================================================
product-grid-item.liquid SHOP Toggle
==============================================================================*/
$('.product-container').each(function(){
    $(this).hover(function(){
        $(this).find('.white-hover-container').toggleClass('white-active');
        $(this).find('.shop-hover').toggleClass('shop-active');
    });
});


/*============================================================================
Black Friday Page // Change 'Shop' to 'Buy'
==============================================================================*/
$('.subscription-grid .shop-hover').text('BUY');


/*============================================================================
One Time vs Coffee Club Accordion
==============================================================================*/
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        $(".radio-active .check-indicator").removeClass("fa-check-square-o").addClass("fa-square-o");
        $(".radio-active").removeClass("radio-active");
        $(".accordion-show").removeClass("accordion-show");

        this.classList.toggle("radio-active");
        this.nextElementSibling.classList.toggle("accordion-show");
        $(this).find("i.check-indicator").removeClass("fa-square-o").addClass("fa-check-square-o");
        console.log($(this).find("i.check-indicator"));
    }
};


/*============================================================================
Club Carousel
==============================================================================*/
$('.reveal-carousel').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    nextArrow: '.modal-select',
    prevArrow: '.carousel-back',
    swipeToSlide: false,
    swipe: false,
    touchMove: false
});


/*============================================================================
Giveaway Carousel
==============================================================================*/
$('.giveaway-carousel').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    nextArrow: '.giveaway-next',
    prevArrow: '.giveaway-back',
    swipeToSlide: false,
    swipe: false,
    touchMove: false
});


/*============================================================================
Sold Out Reveal Carousel
==============================================================================*/
$('.soldout-carousel').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    nextArrow: '.soldout-next',
    prevArrow: '.soldout-back',
    swipeToSlide: false,
    swipe: false,
    touchMove: false
});


/*============================================================================
Win Form
==============================================================================*/
var send = 0;
var emailFilter = /^.+\@.+$/;

function showError( x,y ){
    if ( x ) {
        y.removeClass('input-error');
        y.prev().hide();
        send = 1;
        return send;
    } else {
        y.addClass('input-error');
        y.prev().show();
        send = 0;
        return send;
    }
};

function isEmailValid() {
    var x = emailFilter.test($('#giveaway_email').val());
    var y = $('#giveaway_email');
    return showError( x,y );
};

function isEmailValid2() {
    var x = emailFilter.test($('#soldout_email').val());
    var y = $('#soldout_email');
    return showError( x,y );
};

$('#giveaway-form').on( 'submit',function( e ) {
    e.preventDefault();
    isEmailValid();
    if ( isEmailValid() ) {
        var email = $("#giveaway_email").val();
        $.ajax({
            url:"//api.blackriflecoffee.com/register.php",
            type:"GET",
            data: { email: email },
            success:function(data, textStatus, jqXHR){
                var d = $.parseJSON(data);
                if ( d == "success" ) {
                    $('.enter-to-win-header .slick-slider').slick('slickNext');
                    $('#giveaway-form').prop('disabled');
                }
            }
        });
    } else {
        $(this).prop('disabled');
        return false;
    }
});


$('#soldout-form').on( 'submit',function( e ) {
    e.preventDefault();
    isEmailValid2();
    if ( isEmailValid2() ) {
        var email = $("#soldout_email").val();
        $.ajax({
            url:"//api.blackriflecoffee.com/soldout.php",
            type:"GET",
            data: { email: email },
            success:function(data, textStatus, jqXHR){
                var x = $.parseJSON(data);
                if ( x == "success" ) {
                    $('#soldout-reveal .slick-slider').slick('slickNext');
                    $('#soldout-form').prop('disabled');
                    setTimeout(function(){
                        $('#soldout-reveal').trigger('reveal:close');
                    },4000);
                }
            }
        });
    } else {
        $(this).prop('disabled');
        return false;
    }
});

/*============================================================================
Geolocation Popup
==============================================================================*/

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$( document ).ready(function(){
  $.getJSON("http://geo.blackriflecoffee.com", function( data ){
    var geoPopCookie = getCookie("geoPopup");
    console.log(geoPopCookie);
    if( data.country != 'CA' && !geoPopCookie ) {
        setCookie("geoPopup", 1, 365);
        $("#country-reveal").reveal();
    }
  });
  
  $('select').addClass('needsclick');
});